export type MilestoneKey =
  | "announcement"
  | "bidDeadline"
  | "evaluationStart"
  | "awardDecision"
  | "standstillExpiry"
  | "contractSigning";

export type MilestoneTier = "now" | "auto" | "later";

export interface MilestoneNode {
  key: MilestoneKey;
  labelKey: string;
  derivedKey: string;
  tier: MilestoneTier;
}

// Dynamic t() keys consumed via node.labelKey / node.derivedKey — listed so langen extracts them:
// t('Announcement') t('Bid deadline') t('Evaluation start') t('Award decision') t('Standstill expiry') t('Contract signing')
// t('Set at publication') t('Computed at award')
// The fixed six-step process map. Only "bidDeadline" is an editable input; the rest are derived/read-only.
export const MILESTONE_NODES: readonly MilestoneNode[] = [
  { key: "announcement", labelKey: "Announcement", derivedKey: "Set at publication", tier: "auto" },
  { key: "bidDeadline", labelKey: "Bid deadline", derivedKey: "", tier: "now" },
  { key: "evaluationStart", labelKey: "Evaluation start", derivedKey: "", tier: "later" },
  { key: "awardDecision", labelKey: "Award decision", derivedKey: "", tier: "later" },
  { key: "standstillExpiry", labelKey: "Standstill expiry", derivedKey: "Computed at award", tier: "auto" },
  { key: "contractSigning", labelKey: "Contract signing", derivedKey: "", tier: "later" },
] as const;
